// Services
import { AbstractDataClient } from '~/misc/services/data-client';

// Models
import { ManagerFeatureModel } from '~/modules/manager/models/feature.model';

export class ManagerFeatureDataClient extends AbstractDataClient<ManagerFeatureModel> {
  constructor() {
    super(new ManagerFeatureModel());
  }
}
